<template>
  <div  class="home">
    <body class="as-app-body as-app">
        <div class="as-content">
          <main class="as-main">
            <div class="as-map-area">
              <Map
               v-if="dataLoaded && commercialDataLoaded"
               :districtId="this.$route.params.districtId"
              />
              <div v-else> loading ...</div>
            </div>
          </main>
        <aside class="as-sidebar as-sidebar--left">
          <div v-if="dataLoaded && commercialDataLoaded" class="as-container as-container--border">
            <filters/>
          </div>
          <div v-else> loading ...</div>
        </aside>
      </div>
    </body>
  </div>
</template>
<script>
// Init airship css style
import '@carto/airship-style/dist/airship.css'
// Init airship components
import { defineCustomElements } from '@carto/airship-components/dist/loader'
// Import components
import Filters from '@/components/filters/Filters'
import Map from '@/components/Map'
defineCustomElements(window)

export default {
  name: 'home',
  props: ['lang'],
  components: {
    Map,
    Filters
  },
  mounted () {
    if (this.lang) {
      this.$i18n.locale = this.lang
    }
    this.$store.dispatch('loadMapData')
    this.$store.dispatch('loadCommercialData')
  },
  computed: {
    dataLoaded () {
      return this.$store.state.loaded
    },
    commercialDataLoaded () {
      return this.$store.state.commercialDataLoaded
    }
  }
}
</script>
<style>

as-map-panels {
  width: auto !important;
}
/* Something is overriding the input css
   and was setting the opacity to 0 !
*/
input[type=text] {
  position: absolute;
  opacity: unset;
  z-index: -1;
  left: 0;
  width: auto;
}

.geocoder {
  position: absolute;
  z-index:1;
  width: 100%;
  left:10px;
  bottom:50px;
  }
.mapboxgl-ctrl-geocoder {
    max-width: 280px !important;
    width: 280px !important;
}
.mapboxgl-ctrl-geocoder--input {
  width: unset;
}
.mapboxgl-ctrl-geocoder .suggestions {

    top: unset !important;
    bottom: calc(100% + 6px);
    width: fit-content !important;
}
</style>
